export const removeSpacesFromString = (value: string): string => {
  const val = value || '';

  return val.replace(/\s+/g, '');
};